import { AccountDashboardApi } from "api/dashboard-api"
import { useMutation, useQuery } from "react-query"

export const useAccountDashboard = (
  accountId: any,
) => {
  return useQuery("client", () => AccountDashboardApi(accountId), {
    refetchOnWindowFocus: false,
    // enabled: true,
    refetchInterval: () => 20000
  })
}

